import { isEmpty } from './String';

export const formatPercent = (stringToFormat: string | null): string | null => {
    if (isEmpty(stringToFormat)) {
        return null;
    }

    const valueToFormat: number = parseFloat(stringToFormat as string) / 100;
    if (isNaN(valueToFormat)) {
        return null;
    }

    return valueToFormat.toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
        style: 'percent',
    });
};
